// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pz-z","smallCardRow":"qz-z","largeCardRow":"rz-z","productSearchRow":"sz-z","curatedRow":"tz-z"};